import moment from 'moment'
import {EdgeMemberPolicy} from '../../../types/policiesApi'
import {PhoneProviderActions} from '../../../components/telephony/PhoneProviderActions'

interface IHolderProps {
  members: EdgeMemberPolicy[]
  memberId?: string
  zipCode?: string | null
  stateName?: string | null
  stateCode?: string | null
  countyFips?: string | null
}

export const HolderInfoSide = ({
  members,
  memberId,
  zipCode,
  stateName,
  stateCode,
  countyFips,
}: IHolderProps) => {
  const findHolder = members.find(({node}) => node.rol === 'HOLDER')

  if (!findHolder) {
    return (
      <div className='kt-widget__info d-flex flex-center' style={{height: '120px'}}>
        <span className='kt-widget__label'>There is no information about the owner yet</span>
      </div>
    )
  }

  const {node} = findHolder

  // Calculate totalIncome from up to 3 annualIncome fields
  const incomeFields = [node.annualIncome1, node.annualIncome2, node.annualIncome3]
  /*const totalIncome = incomeFields.reduce((sum, val) => {
    const parsed = typeof val === 'string' ? parseFloat(val.replace(/,/g, '')) : parseFloat(val)
    return !isNaN(parsed) && parsed > 0 ? sum + parsed : sum
  }, 0)*/

  // Calcular totalIncome de todos los miembros, no solo el holder
  const totalIncome = members.reduce((sum, {node}) => {
    const incomes = [node.annualIncome1, node.annualIncome2, node.annualIncome3]
    return (
      sum +
      incomes.reduce((innerSum, val) => {
        const parsed =
          typeof val === 'string' ? parseFloat(val.replace(/,/g, '')) : parseFloat(val)
        return !isNaN(parsed) && parsed > 0 ? innerSum + parsed : innerSum
      }, 0)
    )
  }, 0)

  return (
    <>
      <div className='kt-heading kt-heading--sm custom-border-brand my-3'>Holder Information</div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Holder:</span>
        <span className='kt-widget__data'>
          {node.firstName} {node.lastName}
        </span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Date of birth:</span>
        <span className='kt-widget__data'>
          {' '}
          {node.dateBirth ? moment(node.dateBirth).format('MM/DD/YYYY') : 'N/R'}
        </span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>SSN</span>
        <span className='kt-widget__data'>{node.ssn || 'N/R'}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Phone</span>
        <div className='kt-widget__data'>
          <PhoneProviderActions phone={node.phone} />
        </div>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Location</span>
        <span className='kt-widget__data'>
          {zipCode || stateName || stateCode || countyFips ? (
            <>
              {zipCode ? `${zipCode}` : 'N/R'} •{' '}
              {stateName ? `${stateName}${stateCode ? ` (${stateCode})` : ''}` : 'N/R'} •{' '}
              {countyFips ? `${countyFips}` : 'N/R'}
            </>
          ) : (
            'N/R'
          )}
        </span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Annual Income</span>
        <span className='kt-widget__data' id='household_income_label'>
          {totalIncome > 0 ? totalIncome.toLocaleString('en-US') : 'N/R'}
        </span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Member ID:</span>
        <span className='kt-widget__data'>{memberId || 'N/R'}</span>
      </div>
    </>
  )
}
